<template lang='pug'>
  svg(:class="className" xmlns="http://www.w3.org/2000/svg")
    title(v-if="title") {{ title }}
    use(:xlink:href="`/sprite.svg#${name}`" xmlns:xlink="http://www.w3.org/1999/xlink")
</template>

<script>

export default {
    name: 'VIcon',
    props: {
        name: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: null
        }
    },
    computed: {
        className() {
            return `icon icon_${this.name}`;
        }
    }
};
</script>
